import { render, staticRenderFns } from "./DashboardBody.vue?vue&type=template&id=7b5cf53d&scoped=true"
import script from "./DashboardBody.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardBody.vue?vue&type=style&index=0&id=7b5cf53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cf53d",
  null
  
)

export default component.exports